const rule = {
	name: 'particalCreditCardNumber',
	method: (value, element, params) => !/xxxx-xxxx-xxxx/i.test(value),
	errorMessage: (params, element) => 'Please re-enter your credit card number and expiration date.'
};

export default rule;
